<!-- Loading -->
@if (isLoading()) {
  <div class="flex items-center justify-center min-h-[60vh]">
    <div class="flex flex-col items-center gap-5">
      <div class="relative w-12 h-12">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
      <p class="text-stone-600 font-medium text-sm">Chargement…</p>
    </div>
  </div>
}

@if (!isLoading()) {
  <div class="max-w-[1200px] mx-auto mb-6 px-4 space-y-6">

    <!-- Header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 md:pt-8 px-2 md:px-4">
      <div class="justify-self-start">
        <button (click)="goBack()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux réunions</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">Réunion</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    <!-- Error -->
    @if (errorMessage()) {
      <div class="p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <svg class="w-4 h-4 flex-shrink-0 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"/>
        </svg>
        {{ errorMessage() }}
      </div>
    }

    @if (meeting()) {

      <!-- Action bar -->
      <div class="flex items-center justify-between flex-wrap gap-3">
        <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border"
          [class]="statusBadgeClass(meeting()!.meeting_status)">
          <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
            [class]="meeting()!.meeting_status === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'"></span>
          {{ statusLabel(meeting()!.meeting_status) }}
        </span>

        <div class="flex items-center gap-2 flex-wrap">
          <!-- Status toggle -->
          @if (meeting()!.meeting_status === 'ACTI') {
            <button (click)="confirmStatus('INAC')" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
              </svg>
              Désactiver
            </button>
          } @else {
            <button (click)="confirmStatus('ACTI')" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-emerald-200 text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/>
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              Publier
            </button>
          }

          <!-- Edit -->
          <button (click)="onEdit()" [disabled]="isSaving()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-stone-200 text-stone-600 bg-white hover:bg-stone-50 rounded-lg transition-colors disabled:opacity-50">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125"/>
            </svg>
            Modifier
          </button>

          <!-- Delete -->
          <button (click)="confirmDelete()" [disabled]="isSaving()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-red-200 text-red-600 bg-white hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
            </svg>
            Supprimer
          </button>
        </div>
      </div>

      <!-- Content card -->
      <div class="border border-stone-200 bg-white rounded-2xl shadow-sm overflow-hidden">

        <!-- Photo -->
        @if (meeting()!.photo) {
          <div class="w-full aspect-[16/9] rounded-t-2xl overflow-hidden bg-stone-100 relative flex items-center justify-center">
            <img [src]="meeting()!.photo" aria-hidden="true"
              class="absolute inset-0 w-full h-full object-cover blur-xl scale-110 opacity-70" />
            <img [src]="meeting()!.photo" [alt]="meeting()!.meeting_title"
              class="relative z-10 w-full h-full object-contain" />
          </div>
        } @else {
          <div class="w-full aspect-[16/9] rounded-t-2xl bg-gradient-to-br from-stone-100 to-stone-200 flex flex-col items-center justify-center gap-2 text-stone-400">
            <svg class="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
            </svg>
            <span class="text-xs font-medium">Aucune image</span>
          </div>
        }

        <!-- Meta -->
        <div class="p-6 space-y-3 border-b border-stone-100">
          <h2 class="text-lg font-semibold text-stone-900 leading-snug">{{ meeting()!.meeting_title }}</h2>
          <div class="flex flex-wrap items-center gap-4 text-xs text-stone-500">

            @if (meeting()!.meeting_date) {
              <span class="flex items-center gap-1">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"/>
                </svg>
                {{ formatDate(meeting()!.meeting_date!) }}
              </span>
            }

            @if (meeting()!.meeting_lieu) {
              <span class="flex items-center gap-1">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/>
                </svg>
                {{ meeting()!.meeting_lieu }}
              </span>
            }

            <app-tag-chips [value]="meeting()!.meeting_category" [max]="999"></app-tag-chips>

          </div>
        </div>

        <!-- Participants -->
        @if (meeting()!.meeting_participants) {
          <div class="p-6 border-b border-stone-100 space-y-2">
            <h3 class="text-xs font-bold text-stone-500 uppercase tracking-wider">Participants</h3>
            <p class="text-sm text-stone-700 leading-relaxed whitespace-pre-line">{{ meeting()!.meeting_participants }}</p>
          </div>
        }

        <!-- Compte rendu -->
        @if (meeting()!.meeting_compte_rendu) {
          <div class="p-6 space-y-2">
            <h3 class="text-xs font-bold text-stone-500 uppercase tracking-wider">Compte rendu</h3>
            <p class="text-sm text-stone-700 leading-relaxed whitespace-pre-line">{{ meeting()!.meeting_compte_rendu }}</p>
          </div>
        }

        @if (!meeting()!.meeting_participants && !meeting()!.meeting_compte_rendu) {
          <div class="flex flex-col items-center justify-center py-12 gap-3 text-stone-400">
            <svg class="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
            </svg>
            <p class="text-sm">Aucun détail disponible pour cette réunion.</p>
          </div>
        }

      </div>
    }

    <!-- Status confirmation modal -->
    @if (pendingStatus()) {
      <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
        <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full space-y-4">
          <h3 class="text-base font-semibold text-stone-800">
            {{ pendingStatus()!.status === 'ACTI' ? 'Publier la réunion' : 'Désactiver la réunion' }}
          </h3>
          <p class="text-sm text-stone-600">
            {{ pendingStatus()!.status === 'ACTI'
              ? 'Cette réunion sera visible sur le site public.'
              : 'Cette réunion sera masquée du site public.' }}
          </p>
          <div class="flex items-center justify-end gap-3">
            <button (click)="cancelStatus()"
              class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
              Annuler
            </button>
            <button (click)="applyStatus()"
              class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
              [class]="pendingStatus()!.status === 'ACTI' ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-amber-500 hover:bg-amber-600'">
              {{ pendingStatus()!.status === 'ACTI' ? 'Publier' : 'Désactiver' }}
            </button>
          </div>
        </div>
      </div>
    }

    <!-- Delete confirmation modal -->
    @if (pendingDelete()) {
      <div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
        <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full space-y-4">
          <h3 class="text-base font-semibold text-stone-800">Supprimer la réunion</h3>
          <p class="text-sm text-stone-600">Cette action est irréversible. La réunion sera définitivement supprimée.</p>
          <div class="flex items-center justify-end gap-3">
            <button (click)="cancelDelete()"
              class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
              Annuler
            </button>
            <button (click)="applyDelete()"
              class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-xl transition-colors">
              Supprimer
            </button>
          </div>
        </div>
      </div>
    }

  </div>
}
